import 'css-chunksrc/client/scenes/timeRecordCriteria/styles.scss';export default {
  "timeRecordCriteria": "_timeRecordCriteria_nan7q_1",
  "main": "_main_nan7q_7",
  "field": "_field_nan7q_16",
  "fieldLabel": "_fieldLabel_nan7q_26",
  "fieldRow": "_fieldRow_nan7q_32",
  "numberInput": "_numberInput_nan7q_39",
  "criteriaSection": "_criteriaSection_nan7q_45",
  "sectionTitle": "_sectionTitle_nan7q_53",
  "criteriaList": "_criteriaList_nan7q_59",
  "buttons": "_buttons_nan7q_65"
};